export class QueryParam {
  name: string;
  value: string;

  constructor(name, value:string){
    this.name = name;
    this.value = value;
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/query-param.ts